import { account } from '~/store/account'

export default defineNuxtRouteMiddleware(async () => {
    const localePath = useLocalePath()
    const token = account().accountToken
    if (!token) {
        return navigateTo(localePath('/login'))
    }
})
